import { useTranslation } from 'react-i18next';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ReactComponent as MonitorIcon } from '~/assets/images/monitor.svg';
import SSOLink from '~/components/SSOLink';

import { systemConsoleData } from '../../../../utils/constants';

interface RecoveryConsoleCardProps {
  hostingId: string;
  canShow: boolean;
}

export const RecoveryConsoleCard = ({
  hostingId,
  canShow,
}: RecoveryConsoleCardProps) => {
  const { t } = useTranslation('selfManagedHosting', {
    keyPrefix: 'access',
  });

  return (
    <Card data-testid="recovery-console-card">
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <MonitorIcon />
          <Typography variant="h4">{t('recoveryConsole')}</Typography>
        </Stack>

        <Typography variant="body2" color="text.secondary">
          {t('recoveryConsoleDescription')}
        </Typography>

        <SSOLink
          type={systemConsoleData.type}
          queryParams={systemConsoleData.queryParams}
          fluid
          showIcon
          variant="outlined"
          hostingId={hostingId}
          size="small"
          disabled={!canShow}
        >
          <Typography variant="h3">{t('recoveryButtonText')}</Typography>
        </SSOLink>
      </Stack>
    </Card>
  );
};
